export const TOKEN_VALIDATION = "TOKEN_VALIDATION";
export const LOGIN = "LOGIN";
export const REGISTER = "REGISTER";
export const RESET_PASSWORD = "RESET-PASSWORD";
export const CHANGE_PASSWORD = "CHANGE-PASSWORD";
export const DONE_CHANGE_PASSWORD = "DONE_CHANGE_PASSWORD";